<template>
  <div>
    <el-row :gutter="1">
      <el-col :span="16">
        <!--展示地图区域-->
        <div class="amap-contain">
          <div id="amapContainer" class="map"></div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="route-add-left">
          <el-form ref="form" :model="routeForm">
            <div>
              <el-button id="return-route-list" type="primary" size="small" @click="cancelSave"
                >返回列表</el-button
              >
              <el-form-item label="线路名称:" label-width="90px">
                <span v-text="routeForm.routeName"></span>
              </el-form-item>
              <el-form-item label="状态:" label-width="90px">
                <yd-common-selector v-model="routeForm.status" :options="stateOptions" />
              </el-form-item>
              <el-form-item label="线路类型:" label-width="90px">
                <yd-common-selector v-model="routeForm.routeTypeId" :options="options" />
              </el-form-item>
              <el-form-item label="原城际线路:" label-width="90px">
                <yd-common-selector v-model="routeForm.oldLineId" :options="lineArr" />
              </el-form-item>
            </div>
            <div>
              <el-form-item label="站点配置:" label-width="90px">
                <div style="display: flex; justify-content: flex-end">
                  <el-button type="text" @click="addStation" style="margin-right: 30px"
                    >新增站点</el-button
                  >
                </div>
              </el-form-item>
            </div>
            <el-form-item label-width="20px">
              <el-table :data="routeForm.tableData" size="mini" border>
                <el-table-column align="center" width="150" label="排序">
                  <template slot-scope="scope">
                    <el-form-item label="" :prop="'tableData.' + scope.$index + 'sort'">
                      <el-input-number
                        v-model="scope.row.sort"
                        :min="0"
                        controls-position="right"
                        size="small"
                        @blur="sortStation(scope.row)"
                      />
                    </el-form-item>
                  </template>
                </el-table-column>
                <!--                <el-table-column align="center" width="80" label="类型" prop="typeName">
                  <template slot-scope="scope">
                    <span v-text="scope.row.typeName"></span>
                  </template>
                </el-table-column>-->
                <!--                <el-table-column label="地级归属" prop="areaManageName" width="120" v-show="routeId===-1">
                  <template slot-scope="scope">
                    <el-form-item label="">
                      <el-select v-model="areaManageName" filterable :filter-method="filterRegionData" placeholder="请选择" @focus="refreshParent">
                        <el-option  :value="scope.row.areaManageId" style="height: auto" >
                          <el-tree class="filter-tree" :props="regionProps" :data="areaTreeData" :filter-node-method="filterRegionTreeNode" ref="areaManagerTree" @node-click="handleNodeClick" ></el-tree>
                        </el-option>
                      </el-select>
                      <avue-input-tree
                          v-model="scope.row.areaManageId"
                          placeholder="请选择地级归属"
                          :props="{ label: 'areaName', value: 'id', children: 'childAreaManage' }"
                          type="tree"
                          ref="tree"
                          :dic="areaTreeData"
                          :node-click="getNodeData"
                      >
                      </avue-input-tree>
                    </el-form-item>
                  </template>
                </el-table-column>-->
                <!--routeForm.tableData[scope.$index]. -->

                <!--                :disabled="isEditStationSelect || lineIsBindStationRuleInfo"-->
                <el-table-column
                  label="站点名称"
                  prop="stationName"
                  width="120"
                  v-show="routeId === -1"
                >
                  <template slot-scope="scope">
                    <el-form-item label="">
                      <yd-common-selector v-model="scope.row.stationId" :options="stationList" />
                      <!--                      <avue-select
                          placeholder="请选择站点"
                          :dic="stationList"
                          v-model="scope.row.stationId"
                          :props="{ label: 'stationName', value: 'id' }"
                          @change="selectedStation"
                          style="width: 6vw">
                      </avue-select>-->
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="距起点时间(分钟)" prop="arrTime" width="150">
                  <template slot-scope="scope">
                    <el-form-item label="" :prop="'tableData.' + scope.$index + 'arrTime'">
                      <el-input-number
                        v-model="scope.row.arrTime"
                        :min="0"
                        controls-position="right"
                        size="small"
                        :disabled="scope.$index === 0"
                      />
                    </el-form-item>
                  </template>
                </el-table-column>
                <!--                v-show="scope.$index!==0 && scope.$index!==routeForm.tableData.length-1"-->
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button
                      @click.native.prevent="deleteRow(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
            <el-form-item label-width="20px">
              <el-button v-if="$route.query.id" type="primary" size="mini" @click="handleOperateLog"
                >操作日志</el-button
              >
            </el-form-item>

            <div style="display: flex; justify-content: flex-end; margin-right: 30px">
              <el-button type="info" size="small" @click="cancelSave">取消</el-button>
              <el-button
                type="primary"
                size="small"
                :loading="saveLoading"
                @click="saveRoute(routeId)"
                >保存</el-button
              >
            </div>
          </el-form>
        </div>
      </el-col>
    </el-row>
    <DetailLog ref="detailLog" />
  </div>
</template>

<script>
  import customSearchMap from '@/components/custom-search-map'
  import {
    queryAllFstation,
    addRoute,
    getRoteInfoById,
    lineIsBindStationRule,
    updateRoute,
    getStationByAreaId,
    getLineList
  } from '@/api/transport/routeset'
  import { getRegionTree } from '@/api/belong/addressbelong'
  import DetailLog from './detailLog.vue'
  import { lineType, state } from './enum.data'

  export default {
    name: 'routeSetAdd',
    comments: { customSearchMap },
    components: { DetailLog },
    data() {
      return {
        title: '',
        typeName: '起点',
        typeNameEnd: '',
        routeAddVisible: false,
        map: null,
        routeTypeList: [],
        routeId: -1,
        stationLongLatitude: [], // 线路中所有站点的经纬度
        isEditStationSelect: false, // 是否禁用站点下拉框
        lineIsBindStationRuleInfo: 0, // 线路是否绑定站点规则
        routeForm: {
          routeName: '',
          routeStatus: '',
          routeTypeId: '',
          status: '',
          routeType: '',
          tableData: [],
          oldLineId: '', // 原城际线路
          oldLineName: ''
        },
        stationList: [],
        areaTreeData: [],
        regionProps: {
          id: 'id',
          label: 'areaName',
          children: 'childAreaManage'
        },
        areaManageName: '',
        lineArr: [], // 老城际线路列表
        saveLoading: false
      }
    },
    computed: {
      options() {
        return lineType
      },
      stateOptions() {
        return state
      }
    },
    created() {
      this.routeId = this.$route.query.id
      this.queryLineList()
    },
    mounted() {
      this.init()
      this.getAllStation()
      this.getRouteInfoById(this.$route.query.id)
      this.getLineBindStationInfo(this.$route.query.id)
      this.getAllAddressBelong()
    },
    watch: {
      areaManageName(val) {
        this.$refs.areaManagerTree.filter(val)
      }
    },
    methods: {
      // 查询老城际线路列表
      queryLineList() {
        getLineList().then((res) => {
          if (res && res.code === 0) {
            if (!Array.isArray(res.data)) {
              return
            }
            res.data.forEach((it) => {
              it.label = it.lineName
              it.value = it.lineId
            })
            this.lineArr = res.data
          }
        })
      },
      // 选择不同的站点
      selectedStation(val) {
        // let stationName = ''
        // let obj = {};
        // obj = this.stationList.find((item) => {
        //   return item.id === val
        // })
        // stationName = obj.stationName
      },
      // 获取所有的站点
      getAllStation(val) {
        queryAllFstation(val).then((res) => {
          if (!Array.isArray(res.data)) {
            return
          }
          res.data.forEach((it) => {
            it.label = it.stationName
            it.value = it.id
          })
          this.stationList = res.data
        })
      },

      // 根据地级归属获取站点
      getStationByAreaId(areaManageId) {
        getStationByAreaId(areaManageId)
          .then((res) => {
            this.routeForm.tableData[1].stationList = res.data
          })
          .catch((error) => {
            this.$message.error(error)
          })
      },

      // 获取所有的地级归属
      getAllAddressBelong() {
        getRegionTree().then(({ code, data }) => {
          if (code === 0) {
            this.areaTreeData = data
          }
        })
      },
      // 根据线路id 获取线路信息
      getRouteInfoById(routeId) {
        // this.getLineBindStationInfo(routeId)
        // let startStationName = ''
        // let endStationName = ''
        if (routeId !== undefined) {
          getRoteInfoById(routeId).then((res) => {
            this.routeForm.oldLineId = res.data.oldLineId
            this.routeForm.oldLineName = res.data.oldLineName
            const stationInfoList = [] // 站点信息集合
            res.data.lineStationVoList.forEach((item, index) => {
              /* let longLatitude = {
                lng: 0.000000,
                lat: 0.0000
              } //站点经纬度 */
              const longLatitude = []
              const stationInfo = {
                sort: '',
                arrTime: '',
                stationId: '',
                typeName: '',
                lineId: ''
              }
              stationInfo.stationId = item.stationId
              stationInfo.arrTime = item.arrTime
              stationInfo.lineId = item.lineId
              stationInfo.sort = item.sort
              if (index === 0 || index === '0') {
                stationInfo.typeName = '起点'
                // startStationName = item.stationName
              }
              if (index === res.data.lineStationVoList.length - 1) {
                // endStationName = item.stationName
                stationInfo.typeName = '终点'
              }
              if (index !== 0 && index !== res.data.lineStationVoList.length - 1) {
                stationInfo.typeName = '经过'
              }
              stationInfoList.push(stationInfo)
              longLatitude.push(parseFloat(item.longitude))
              longLatitude.push(parseFloat(item.latitude))
              /* longLatitude.lng = parseFloat(item.longitude)
              longLatitude.lat = parseFloat(item.latitude) */
              this.stationLongLatitude.push(longLatitude)
            })
            this.routeForm.tableData = stationInfoList
            // this.routeForm.routeName = startStationName+"-"+endStationName
            this.routeForm.routeName = res.data.lineName
            if (res.data.statusStr === '正常') {
              this.routeForm.status = 1
            } else {
              this.routeForm.status = 2
            }
            /* 1普通线；2旅游线；3校园线；4接驳线；5机场线 */
            if (res.data.typeStr === '普通线') {
              this.routeForm.routeTypeId = 1
            }
            if (res.data.typeStr === '旅游线') {
              this.routeForm.routeTypeId = 2
            }
            if (res.data.typeStr === '校园线') {
              this.routeForm.routeTypeId = 3
            }
            if (res.data.typeStr === '接驳线') {
              this.routeForm.routeTypeId = 4
            }
            if (res.data.typeStr === '机场线') {
              this.routeForm.routeTypeId = 5
            }
          })
        }
      },

      // 新增线路经过点
      addStation() {
        /* this.routeForm.tableData.splice(this.routeForm.tableData.length-1,0,{
          sort: '',
          arrTime: '',
          stationId: '',
          areaManageId: '',
          stationList: [],
          typeName: '经过'
        }) */
        this.routeForm.tableData.push({
          sort: '',
          arrTime: '',
          stationId: '',
          areaManageId: '',
          stationList: [],
          typeName: ''
        })
        if (this.routeForm.tableData.length === 1) {
          this.routeForm.tableData[0].sort = 0
        } else {
          this.routeForm.tableData[this.routeForm.tableData.length - 1].sort =
            this.routeForm.tableData[this.routeForm.tableData.length - 1 - 1].sort + 1
        }
      },
      // 取消新增线路站点
      cancelSave() {
        this.returnIndex('/routelist')
      },
      // 返回
      returnIndex(url) {
        this.$router.push({ path: url })
      },
      // 删除线路
      deleteRow(index) {
        if (index !== -1) {
          this.routeForm.tableData.splice(index, 1)
        }
        this.routeForm.tableData.forEach((item, index) => {
          if (index === 0) {
            item.arrTime = 0
          }
        })
        /* if (index !==-1) {
          this.routeForm.tableData.splice(index,1)
        } */
      },

      sortStation(row) {
        this.routeForm.tableData.sort((a, b) => {
          return a.sort - b.sort
        })
        this.routeForm.tableData.forEach((item, index) => {
          if (index === 0) {
            item.arrTime = 0
          }
        })
      },

      // 判断线路是否绑定站点规则
      getLineBindStationInfo(lineId) {
        if (lineId !== undefined) {
          lineIsBindStationRule(lineId).then((res) => {
            this.lineIsBindStationRuleInfo = res.data
          })
        }
      },
      // 保存线路
      saveRoute(lineId) {
        // 如果id不存在则保存
        if (lineId === undefined) {
          this.routeForm.tableData.forEach((tableItem, tableIndex) => {
            tableItem.sort = tableIndex
          })
          // let startStationName = ''
          // let endStationName = ''
          // let lineNameStr = startStationName + endStationName
          this.routeForm.tableData.forEach((tableItem, tableIndex) => {
            // tableItem.sort = tableIndex
            this.stationList.forEach((stationItem, index) => {
              if (index === 0) {
                // startStationName = stationItem.name
              }
              if (index === this.stationList.length - 1) {
                // endStationName = stationItem.name
              }
            })
          })
          if (!this.routeForm.tableData.length) {
            this.$message.error('站点不能为空')
            return
          }
          const lineStationData = {
            endStationId: this.routeForm.tableData[this.routeForm.tableData.length - 1].stationId,
            lineStationDtoList: this.routeForm.tableData,
            startStationId: this.routeForm.tableData[0].stationId,
            status: this.routeForm.status,
            lineName: '',
            // "lineName": lineNameStr,
            type: this.routeForm.routeTypeId,
            oldLineId: this.routeForm.oldLineId
          }
          this.saveLoading = true
          addRoute(lineStationData)
            .then((res) => {
              if (res.code !== 0) {
                this.saveLoading = false
                return
              }
              this.$message.success('保存成功！')
              this.cancelSave()
              this.saveLoading = false
            })
            .catch((error) => {
              this.$message.error(error)
              this.saveLoading = false
            })
        }
        if (lineId !== undefined) {
          const lineStationData = {
            id: this.routeId,
            endStationId: this.routeForm.tableData[this.routeForm.tableData.length - 1].stationId,
            lineStationDtoList: this.routeForm.tableData,
            startStationId: this.routeForm.tableData[0].stationId,
            status: this.routeForm.status,
            lineName: this.routeForm.routeName,
            type: this.routeForm.routeTypeId,
            oldLineId: this.routeForm.oldLineId
          }
          this.saveLoading = true
          updateRoute(lineStationData)
            .then((res) => {
              if (res.code !== 0) {
                this.saveLoading = false
                return
              }
              this.$message.success('编辑成功！')
              this.cancelSave()
              this.saveLoading = false
            })
            .catch((error) => {
              this.$message.error(error)
              this.saveLoading = false
            })
        }

        /* this.$nextTick(() => {
          setTimeout(() => {
            this.initMapDragRoute(() => {
              this.loadLineMap()
            })
          }, 5000)
        }) */
      },
      init() {
        this.$nextTick(() => {
          setTimeout(() => {
            this.initMapDragRoute(() => {
              this.loadLineMap()
            })
          }, 3000)
          /* this.initMapDragRoute(() => {
            this.loadLineMap()
          }) */
        })
      },
      // 初始化线路地图
      initMapDragRoute(callBack) {
        const that = this
        that.AMap = window.AMap
        this.AMap.plugin(['AMap.ControlBar', 'AMap.DragRoute'], function () {})
        this.map = new this.AMap.Map('amapContainer', {
          zoom: 12,
          pitch: 80,
          rotation: 0
          // buildingAnimation: true,//楼块出现是否带动画
        })
        this.map.addControl(new this.AMap.ControlBar())
        if (callBack && typeof callBack == 'function') {
          callBack()
        }
      },
      // 加载路线
      loadLineMap() {
        const that = this
        that.AMap = window.AMap
        let path = []
        path = this.stationLongLatitude
        /* path.push([102.719804, 25.0151])
        path.push([102.947084, 25.080417])
        path.push([103.584312, 25.429818])
        path.push([103.797858, 25.492433])
        console.log(5555,path) */
        that.route = new that.AMap.DragRoute(that.map, path, that.AMap.DrivingPolicy.LEAST_FEE)
        that.route.search()
      },

      filterRegionData(val) {
        this.areaManageName = val
      },

      // 重置父级区域的搜索条件
      refreshParent() {
        this.areaManageName = ''
      },

      filterRegionTreeNode(value, data) {
        if (!value) return true
        return data.areaName.indexOf(value) !== -1
      },

      // 点击节点事件
      /* handleNodeClick(data) {
        console.log('点击的data是：', data)
      }, */

      getNodeData(data) {
        // this.getStationByAreaId(data.id)
      },
      handleOperateLog() {
        this.$nextTick(this.$refs.detailLog.init(this.$route.query.id))
      }
    }
  }
</script>

<style lang="scss" scoped>
  .amap-contain {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    width: 100%;
    height: 100vh;
    display: flex;
    .map {
      width: 100%;
      height: 100vh;
    }
  }
  #save-route-btn {
    margin-left: 450px;
  }
  #cancel-save-btn {
    margin-left: 450px;
  }
  #return-route-list {
    margin-left: 450px;
  }
</style>
